// Bearer-token helper for the API client.
//
// Prod: pulls the current Firebase ID token. The browser obtained its
//       Firebase session by exchanging a custom token minted by the Go
//       backend's OPEN `POST /api/auth/signin` endpoint (the firewall-safe
//       replacement for client-side Clerk). The Go backend's verifier
//       validates the Firebase ID token (signature + issuer + expiry) and
//       the `sub`/`uid` claim becomes Deck.OwnerID server-side.
// Dev:  returns the fixed string "dev-token-local" that the Go FakeVerifier
//       recognises when AUTH_DISABLED=true.

import { getFirebaseAuth, isDevBypass } from './firebase';

/** Returns a Bearer token suitable for `Authorization: Bearer ${token}`.
 *  Empty string means "no token available" — the caller should omit the
 *  header rather than send `Bearer `. */
export async function getToken(): Promise<string> {
  if (isDevBypass()) return 'dev-token-local';
  const auth = await getFirebaseAuth();
  if (!auth || !auth.currentUser) return '';
  try {
    const token = await auth.currentUser.getIdToken();
    return token ?? '';
  } catch {
    return '';
  }
}
